import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';

import { container, containerMargins } from './styles.module.css';

/**
 * Container presentational component.
 */
const Container = ({ className, children, hideMargins }) => {
  return (
    <div
      className={cx(container, className, { [containerMargins]: !hideMargins })}
    >
      {children}
    </div>
  );
};

Container.propTypes = {
  /**
   * Children contents of container.
   */
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
};

Container.defaultProps = {
  children: null,
  className: '',
};

export default Container;
